import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type BaseScoreEntry = {
  id: string;
  teamId: string;
  roundIndex: number;
  extraScores?: Record<string, number>;
  submittedAt: string | null;
  updatedAt: string;
};

const base = config.apiUrl;

export const scoresApi = {
  async listScores(
    eventId: string,
    judgeNumber: 1 | 2 | 3,
    roundIndex = 1,
  ): Promise<BaseScoreEntry[]> {
    const q =
      roundIndex === 1
        ? ""
        : `?roundIndex=${encodeURIComponent(String(roundIndex))}`;
    return fetcher.get<BaseScoreEntry[]>(
      `${base}/events/${eventId}/scores/judge${judgeNumber}${q}`,
    );
  },

  async saveScore(
    eventId: string,
    judgeNumber: 1 | 2 | 3,
    teamId: string,
    data: Record<string, number | Record<string, number>>,
    roundIndex = 1,
  ): Promise<BaseScoreEntry> {
    const q =
      roundIndex === 1
        ? ""
        : `?roundIndex=${encodeURIComponent(String(roundIndex))}`;
    return fetcher.put<BaseScoreEntry>(
      `${base}/events/${eventId}/scores/judge${judgeNumber}/${teamId}${q}`,
      data,
    );
  },
};
